module.exports = __webpack_public_path__ + "img/dress-detail-front.47ea98b2.jpg";